export interface AuthRequestModel {
  userId: string;
  authId: string;
}


export interface AuthStateModel {
  auth: AuthModel;
  loading: boolean;
  error: any | null;
}

export enum OTP_MEANS {
  APP = 'App',
  EMAIL = 'Email',
  NONE = 'App',
}

export interface AuthModel {
  authToken: string | null;
  token: string | null;
  refreshToken: string | null;
  id: string | null,
  email: string | null,
  isOtpEnabled: boolean,
  otpMeans: "App" | "Email" | "None",
  isStaff: boolean,
  user: UserModel | null,
}

export interface UserModel {
  _id: string;
  firstName: string;
  lastName: string;
  avatar: string;
  examType: string;
  email: string;
}

